<template>
  <div>
    <b-button-toolbar class="button-toolbar-ptc" aria-label="Toolbar with button groups and dropdown menu">
      <div class="mx-1 ml-auto">
        <router-link :to="{ name: 'role_management_add' }" class="btn btn-ptc1" tag="button">完成</router-link>
      </div>
    </b-button-toolbar>
    <div style="padding: 0.75rem">
      <b-form @submit="onSubmit" @reset="onReset" style="padding: 0.75rem">
        <b-form-group id="exampleInputGroup1"
                      label="簡訊認證碼逾時時間 ( 分鐘 )"
                      label-for="exampleInput1">
          <b-form-input id="exampleInput1"
                        type="number"
                        required
                        placeholder="簡訊認證碼逾時時間"
                        value="5">
          </b-form-input>
        </b-form-group>
      </b-form>
    </div>
  </div>
</template>

<script>
const breadcrumbItems = [
  { text: '系統管理', active: true },
  { text: '權限角色管理', to: { name: 'role_management' } },
  { text: '新增角色', active: true }
]
const tableItems = [
  { '角色名稱': '系統管理員', '狀態': '啟用' },
  { '角色名稱': '行銷經理', '狀態': '啟用' },
  { '角色名稱': '資訊經理', '狀態': '啟用' },
  { '角色名稱': '行政助理', '狀態': '啟用' }
]

export default {
  name: 'HelloWorld',
  data () {
    return {
      breadcrumbItems: breadcrumbItems,
      tableItems: tableItems
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.ui-breadcrumb {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/system/smsSetting.vue